/** biome-ignore-all lint/nursery/noRestrictedElements: Don't want to import stuff for the bundle */
import { ChevronRight, Clock, Mail, RefreshCcw } from 'lucide-react';
import type { ReactNode } from 'react';
import { Error500Icon } from '@/app_components/icons/Error500Icon';

export const InternalError = () => {
  const items: { icon: ReactNode; text: ReactNode; id: string }[] = [
    {
      icon: (
        <RefreshCcw
          absoluteStrokeWidth
          strokeWidth={1.5}
        />
      ),
      id: 'RefreshCcw',
      text: <p>Refresh the page</p>,
    },
    {
      icon: (
        <Clock
          absoluteStrokeWidth
          strokeWidth={1.5}
        />
      ),
      id: 'Clock',
      text: (
        <p>
          <span className='font-medium'>Visit our homepage</span> to explore our latest stories.
        </p>
      ),
    },
    {
      icon: (
        <Mail
          absoluteStrokeWidth
          strokeWidth={1.5}
        />
      ),
      id: 'Mail',
      text: (
        <p>
          <span className='font-medium'>
            Reach out to us at{' '}
            <a
              aria-label='share with email'
              className='text-blue-500 dark:text-blue-300 hover:text-primary-hover active:text-primary-pressed visited:text-primary-visited'
              href='mailto:support@fortune.com'
              rel='noopener noreferrer'
              target='_blank'
            >
              support@fortune.com
            </a>
          </span>{' '}
          if you need assistance or have questions.
        </p>
      ),
    },
  ];

  return (
    <div className='flex flex-col w-full py-10 px-5 gap-12 lg:flex-row-reverse lg:justify-around h-full'>
      <Error500Icon className='w-[320px] h-[110px] md:w-[468px] md:h-[162px] xl:w-[545px] xl:h-[188px] self-center' />
      <div className='flex flex-col gap-10 self-stretch'>
        {/* Title */}
        <div className='flex flex-col gap-6 self-stretch'>
          <h1 className='font-inria-serif typography-level-3 font-bold'>Our systems need a quick pivot.</h1>
          <p className='typography-level-6'>We’re addressing the issue and hope to have it fixed soon.</p>
        </div>

        {/* Actions */}
        <div className='flex flex-col items-start gap-2 self-stretch typography-sm'>
          <p>Here’s what you can do in the meantime:</p>
          <ul className='flex flex-col pl-2 gap-4'>
            {items.map(({ icon, text, id }) => (
              <li
                className='flex items-center gap-2'
                key={id}
              >
                {icon}
                {text}
              </li>
            ))}
          </ul>
        </div>

        {/* Homepage */}
        <div className='contents md:block'>
          <a
            className='group/button inline-flex capitalize items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors disabled:cursor-not-allowed disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:pointer-events-none cursor-pointer rounded-full button-shadow-focus outline-none focus-visible:ring-4 leading-none button-h-md button-v-md typography-default button-primary button-primary-hover disabled:button-primary-disabled button-text-primary disabled:button-text-primary-disabled active:button-primary'
            href='https://fortune.com'
          >
            <span>Go to Homepage</span>
            <ChevronRight />
          </a>
        </div>
      </div>
    </div>
  );
};
